import { registerWidget } from "dmeditor";
import definition from "./definition";
import { ClubDropdown } from "./ClubDropdown";
import { serverImport } from "../../serverImport";

const register = () => {
  registerWidget(definition, {
    render: ClubDropdown,
    onServerSideLoad: serverImport(() => import("./onServerSide")),
  });
};

export default register;
